// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__31JYy","rootSmall":"AddTileButton_rootSmall__7v25d"};